import React from "react";
import { Combobox } from "@/components/ui/Combobox";
import { Label } from "@/components/ui/Label";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const RoleSelector = () => {
    const { user, isAdmin, isSuperAdmin } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const isAdminUser = isAdmin || isSuperAdmin;

    const reviewerRoles = [
        { name: "Field Engineer", value: "field-engineer", href: "/field-engineer-reports" },
        { name: "Peer Reviewer", value: "peer-reviewer", href: "/peer-reviewer-reports" },
        { name: "Site Reviewer", value: "site-reviewer", href: "/site-reviewer-reports" },
        { name: "Director Reviewer", value: "director-reviewer", href: "/director-reviewer-reports" },
    ];

    const getAvailableReviewerRoles = () => {
        const userRoles = (user?.roles || []).map((r) => r?.toString?.() || "").filter(Boolean);
        if (userRoles.length === 0) return [];

        const normalized = new Set(
            userRoles.flatMap((r) => {
                const lower = r.toLowerCase();
                return [lower, lower.replace(/\s+/g, "-")];
            })
        );

        return reviewerRoles.filter(
            (role) => normalized.has(role.value) || normalized.has(role.name.toLowerCase())
        );
    };

    const roles = getAvailableReviewerRoles();
    if (isAdminUser || roles.length <= 1) return null;

    return (
        <div className="flex items-center w-full gap-2 space-y-3">
            <Label htmlFor="roleMenu" className="w-1/2 pl-3 text-xs font-medium text-center uppercase text-gray-0">
                Selection of role
            </Label>
            <Combobox
                id="roleMenu"
                className="!m-0"
                options={roles.map((role) => ({
                    value: role.href,
                    label: role.name,
                }))}
                value={roles.find((r) => location.pathname.startsWith(r.href))?.href || ""}
                onValueChange={(href) => {
                    if (href && href !== location.pathname) navigate(href);
                }}
                placeholder="SELECT ROLE"
            />
        </div>
    );
};

export default RoleSelector;
